import Input from 'components/Input';
import { ENUM_TYPE_OPTION } from 'constants/enum';
import { TEXT_CREATE_SURVEY } from 'constants/string/texts';

const DropdownOption = (props) => {
  const { isPreview, renderOptions } = props;

  return (
    <>
      {isPreview ? (
        <Input
          value={null}
          readOnly
          disabled={true}
          list={[{ text: TEXT_CREATE_SURVEY.PLACEHOLDER_DROPDOWN, value: null }]}
          type="dropdown"
          placeholder={TEXT_CREATE_SURVEY.PLACEHOLDER_DROPDOWN}
          className="w-full"
          classNameInput="rounded-lg w-full !text-secondary-354 !block line-clamp-1 text-ellipsis break-words"
        />
      ) : (
        renderOptions(ENUM_TYPE_OPTION.DROPDOWN)
      )}
    </>
  );
};

export default DropdownOption;
